import React from "react";
import { connect } from "react-redux";
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import routes from "../../../assets/apiRoutes.json";
import TextBox from 'devextreme-react/text-box';
import axios from "axios";
import notify from 'devextreme/ui/notify';
import DataSource from "devextreme/data/data_source";
import ArrayStore from 'devextreme/data/array_store';
import {
    Validator,
    RequiredRule,
    StringLengthRule
} from 'devextreme-react/validator';
import NumberBox from 'devextreme-react/number-box';
import ValidationSummary from 'devextreme-react/validation-summary';
import TextArea from 'devextreme-react/text-area';
let accessToken = '';
const orchardCodesSelectBox = React.createRef();
const blockCodesSelectBox = React.createRef();

class AddTMLocationCodes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orchard: "",
            block: "",
            code: "",
            description: "",
            status: "A",
            positionx: "",
            positiony: "",
            comment: "",
            disableBlock: true
        };
        accessToken = props.oidc.user.access_token;
        this.SaveRecord = this.SaveRecord.bind(this);
        this.OrchardCodeChanged = this.OrchardCodeChanged.bind(this);
        this.BlockCodeChanged = this.BlockCodeChanged.bind(this);
        this.LoadOrchardCodes = this.LoadOrchardCodes.bind(this);
        this.LoadBlockCodes = this.LoadBlockCodes.bind(this);
        this.Reset = this.Reset.bind(this);
        this.statusArr = [{ id: 1, name: 'Active', value: 'A' }, { id: 2, name: 'Inactive', value: 'I' },  { id: 3, name: 'Unavailable', value: 'U' }];
    }

    componentDidMount() {
        this.LoadOrchardCodes();
    }

    LoadOrchardCodes() {
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.Orchard.GetOrchardCodesLookUp}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let OrchardCodesDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                orchardCodesSelectBox.current.instance().option(
                    "dataSource",
                    OrchardCodesDataStore
                );
                orchardCodesSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
            })
            .catch((err) => {
                console.log(err, "Error in loading orchard codes");
            });
    }

    LoadBlockCodes() {
        let _id = this.state.orchard;
        axios.get(`${window._env_.REACT_APP_APIS}/${routes.Blocks.GetBlockCodesLookUp}?rowid=${_id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                let blockCodesDataStore = new DataSource({
                    store: new ArrayStore({
                        data: response.data
                    }),
                    paginate: true,
                    pageSize: 100
                });
                blockCodesSelectBox.current.instance().option(
                    "dataSource",
                    blockCodesDataStore
                );
                blockCodesSelectBox.current.instance().option(
                    "acceptCustomValue",
                    false
                );
                this.setState({
                    disableBlock: false
                });
            })
            .catch((err) => {
                console.log(err, "Error in loading block codes");
            });
    }

    OrchardCodeChanged(e) {
        this.setState({
            orchard: e.value,
            block: "",
            disableBlock: true
        });
        this.LoadBlockCodes();
    }

    BlockCodeChanged(e) {
        this.setState({
            block: e.value,
        });
    }

    Reset() {
        this.setState({
            orchard: "",
            block: "",
            code: "",
            description: "",
            status: "A",
            positionx: "",
            positiony: "",
            comment: "",
            disableBlock: true
        });
    }
    SaveRecord(e) {
        e.preventDefault();

        var rqst = this.state;
        axios.post(`${window._env_.REACT_APP_APIS}/${routes.TMLocation.InsertLocationCode}`, rqst,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                if (res.data == "Location code already exist.") {
                    notify({
                        message: 'Location code already exist!',
                        width: 100,
                    }, 'error', 2000);
                }
                else {
                    notify({
                        message: 'Record Saved!',
                        width: 100,
                    }, 'success', 2000);
                    this.props.parentCallback();
                    this.Reset();
                }
            }).catch((err) => {
                notify({
                    message: 'Couldnt Save Data!!',
                    width: 450,
                }, 'error', 2000);
            });
    }
    render() {
        return (
            <div>
                {/*onSubmit={(e) => onSearchTransaction(e)}*/}
                <form onSubmit={(e) => this.SaveRecord(e)}>
                    <div className="row">
                        <label htmlFor="orchard-sb" className="field-label">
                            Orchard
                        </label>
                        <SelectBox
                            ref={orchardCodesSelectBox}
                            searchEnabled={true}
                            placeholder="Select Orchard"
                            onValueChanged={this.OrchardCodeChanged}
                            displayExpr="name"
                            valueExpr="id"
                            name="orchard-sb"
                            className="w-100"
                            value={this.state.orchard}
                            acceptCustomValue={true}>
                            <Validator>
                                <RequiredRule message="Orchard Code is required." />
                            </Validator>
                        </SelectBox>
                    </div>
                    <div className="row">
                        <label htmlFor="block-sb" className="field-label">
                            Block
                        </label>
                        <SelectBox
                            ref={blockCodesSelectBox}
                            searchEnabled={true}
                            disabled={this.state.disableBlock}
                            placeholder="Select Block"
                            onValueChanged={this.BlockCodeChanged}
                            displayExpr="name"
                            valueExpr="id"
                            name="block-sb"
                            className="w-100"
                            value={this.state.block}
                            acceptCustomValue={true} />
                    </div>
                    <div className="row">
                        <label htmlFor="locationcode" className="field-label">
                            Code
                        </label>
                        <TextBox
                            id="location-code"
                            className="input-field"
                            type="text"
                            placeholder="Enter Location Code"
                            onValueChanged={(data) => this.setState({ code: data.value })}
                            name="locationcode"
                            value={this.state.code}>
                            <Validator>
                                <RequiredRule message="Code(Location) is required." />
                                <StringLengthRule message="Code must have at least 3 chracters and maximum 20" min={3} max={20} />
                            </Validator>
                        </TextBox>
                    </div>
                    <div className="row">
                        <label htmlFor="locationdescription" className="field-label">
                            Description
                        </label>
                        <TextBox
                            id="location-description"
                            className="input-field"
                            type="text"
                            placeholder="Enter Description"
                            onValueChanged={(data) => this.setState({ description: data.value })}
                            name="locationdescription"
                            value={this.state.description}>
                            <Validator>
                                <StringLengthRule message="Description must have at least 3 chracters and maximum 40" min={3} max={50} />
                            </Validator>
                        </TextBox>
                    </div>
                    <div className="row">
                        <label htmlFor="status-sb" className="field-label">
                            Status
                        </label>
                        <SelectBox
                            displayExpr="name"
                            valueExpr="value"
                            dataSource={this.statusArr}
                            name="status-sb"
                            className="w-100"
                            defaultValue={"A"}
                            value={this.state.status}
                            onValueChanged={(data) => this.setState({ status: data.value })}
                        />
                    </div>
                    <div className="row">
                        <label htmlFor="locationpositionx" className="field-label">
                            Position X
                        </label>
                        <NumberBox
                            id="location-position-x"
                            placeholder="Enter Position X"
                            name="locationpositionx"
                            className="input-field"
                            format="#"
                            min={0}
                            value={this.state.positionx}
                            onValueChanged={(data) => this.setState({ positionx: data.value })} />
                    </div>
                    <div className="row">
                        <label htmlFor="locationpositiony" className="field-label">
                            Position Y
                        </label>
                        <NumberBox
                            id="location-position-y"
                            placeholder="Enter Position Y"
                            name="locationpositiony"
                            className="input-field"
                            format="#"
                            min={0}
                            value={this.state.positiony}
                            onValueChanged={(data) => this.setState({ positiony: data.value })} />
                    </div>

                    <div className="row">

                        <label htmlFor="locationcomment" className="field-label">
                            Comment
                        </label>
                        <TextArea
                            id="location-comment"
                            className="input-field"
                            placeholder="Enter Comment"
                            onValueChanged={(data) => this.setState({ comment: data.value })}
                            name="locationcomment"
                            value={this.state.comment}
                            height={90}
                        />
                    </div>
                    <div className="row accordianLastRow">
                        <div className="col-md-12 pl-4 mt-5 mb-5">
                            <ValidationSummary id="summary" />
 
                            <Button
                                    text="Save Record"
                                    type="default"
                                    useSubmitBehavior={true}
                                    stylingMode="contained">
                                </Button>
                                <Button
                                    onClick={this.Reset}
                                    style={{marginLeft:'10px'}}
                                    text="Reset"
                                    useSubmitBehavior={false}
                                    stylingMode="contained">
                                </Button>
                             
                        </div>
                    </div>
                </form >
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(AddTMLocationCodes);